import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { CheckIcon1Svg } from "../../svgs/checkIcon1Svg";
import { RemoveIcon1Svg } from "../../svgs/removeIcon1Svg";
import { redirectToWhatsapp } from "../../utils/redirectToWhatsapp";
import GenerateFirstLetterBox from "../../components/generateFirstLetterBox";
import CommentModal from "../../components/commentModal";
import CUSTOMERS from "../../api/services/CUSTOMERS";
import CLASS from "../../api/services/CLASS";
import APPOINTMENTS from "../../api/services/APPOINTMENTS";
import styles from "../../styles/_containers/_class/participants.module.scss";

const Participants = ({ members, appointmentId, onDataChange }) => {
  const [healthMap, setHealthMap] = useState({});
  const [commentModalFor, setCommentModalFor] = useState(null);

  // Fetch health declaration status for all members once
  useEffect(() => {
    if (!members || members.length === 0) return;
    const fetchHealth = async () => {
      const map = {};
      await Promise.all(
        members.map(async (m) => {
          try {
            const res = await CUSTOMERS.get_by_id(m.userId);
            map[m.userId] = !!res.data.isHealthCheckCompleted;
          } catch {
            map[m.userId] = false;
          }
        })
      );
      setHealthMap(map);
    };
    fetchHealth();
  }, [members]);

  // Mark attendance
  const markAttendance = async (hasAttended, userId) => {
    try {
      await CLASS.mark_attendance({ appointmentId, userId, hasAttended });
      onDataChange();
    } catch (error) {
      console.log(error);
      toast.error("שגיאה בעדכון נוכחות");
    }
  };

  // Send manual reminder
  const handleReminder = async (userId) => {
    try {
      const res = await APPOINTMENTS.send_reminder({ userId, appointmentId });
      toast.success(res.data.message);
    } catch (error) {
      console.log(error);
      toast.error("שגיאה בשליחת תזכורת");
    }
  };

  // Cancel specific participant (not entire class)
  const handleCancelParticipant = async (userId) => {
    if (!window.confirm("האם לבטל את התור של משתתף/ת זה?")) return;
    try {
      const res = await APPOINTMENTS.cancel_appointment({
        id: appointmentId,
        userId,
        status: 3,
      });
      toast.success(res.data.message);
      onDataChange();
    } catch (error) {
      console.log(error);
      toast.error("שגיאה בביטול");
    }
  };

  const getStatusBadge = (hasAttended) => {
    if (hasAttended === true)
      return <span className={styles.badgeSuccess}>אישר/ה הגעה</span>;
    if (hasAttended === false)
      return <span className={styles.badgeError}>לא מגיע/ה</span>;
    return <span className={styles.badgePending}>ממתין לאישור</span>;
  };

  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        משתתפים
        <span className={styles.count}>{members.length}</span>
      </div>

      {members.length === 0 ? (
        <div className={styles.emptyState}>אין משתתפים רשומים לשיעור</div>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>שם</th>
                <th>נוכחות</th>
                <th>סטטוס</th>
                <th>הצהרת בריאות</th>
                <th>פעולות</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.userId}>
                  <td>
                    <div className={styles.customer}>
                      <GenerateFirstLetterBox name={m.userName} />
                      <h5>{m.userName}</h5>
                    </div>
                  </td>

                  <td>
                    <div className={styles.attendBtns}>
                      <button
                        onClick={() => markAttendance(true, m.userId)}
                        title="אישור הגעה"
                      >
                        <CheckIcon1Svg fill="#06A816" />
                      </button>
                      <button
                        onClick={() => markAttendance(false, m.userId)}
                        title="לא הגיע/ה"
                      >
                        <RemoveIcon1Svg fill="#FF0000" />
                      </button>
                    </div>
                  </td>

                  <td>{getStatusBadge(m.hasAttended)}</td>

                  <td>
                    {healthMap[m.userId] ? (
                      <span className={styles.healthYes}>מאושר</span>
                    ) : (
                      <span className={styles.healthNo}>לא קיים</span>
                    )}
                  </td>

                  <td>
                    <div className={styles.actions}>
                      {m.userPhone && (
                        <a href={`tel:+972${m.userPhone}`}>
                          <button title="חיוג">
                            <img src="/assets/phone-icon-1.svg" alt="phone" />
                          </button>
                        </a>
                      )}
                      {m.userPhone && (
                        <button
                          onClick={() => redirectToWhatsapp(m.userPhone)}
                          title="WhatsApp"
                        >
                          <img
                            src="/assets/whatsapp-icon-1.svg"
                            alt="whatsapp"
                          />
                        </button>
                      )}
                      <button
                        onClick={() => handleReminder(m.userId)}
                        title="שליחת תזכורת"
                      >
                        <img
                          src="/assets/paper-plane-icon-1.svg"
                          alt="reminder"
                        />
                      </button>
                      <button
                        onClick={() => setCommentModalFor(m.userId)}
                        title="הוספת הערה"
                      >
                        <img src="/assets/write-icon-1.svg" alt="comment" />
                      </button>
                      <button
                        onClick={() => handleCancelParticipant(m.userId)}
                        title="ביטול תור"
                      >
                        <img src="/assets/remove-icon-1.svg" alt="cancel" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {commentModalFor && (
        <CommentModal
          setIsOpen={() => setCommentModalFor(null)}
          appointmentId={appointmentId}
        />
      )}
    </div>
  );
};

export default Participants;
